<footer class="footer">
  <div
    class="ac-sp-btw"
    [ngClass]="{
      'ac-flex': device.gtXsScreen(),
      'ac-flex-col': device.isXsScreen(),
    }"
  >
    <div class="ac-flex-col" [class.ac-ctr]="device.isXsScreen()">
      <div class="logo-container ac-flex ac-algn-ctr ac-gap-sm">
        <ac-icon iconKey="brand:gains_filled" [size]="24" class="filled-icon" />
        <ac-icon iconKey="brand:gains_text" [size]="112" [useWidth]="true" />
      </div>

      <div class="ac-body-sm ac-label ac-mg-lg-0">
        © 2025 GamerGains Labs, Inc. | All Rights Reserved. | v{{ version }}
      </div>

      <div class="soc-links ac-flex ac-gap-sm">
        @for (socialLink of socialLinks; track socialLink.link) {
          <button mat-icon-button class="ac-icon-btn-sm ac-label social-link" (click)="openLink(socialLink.link)">
            <ac-icon [iconKey]="socialLink.iconKey" [size]="20" />
          </button>
        }
      </div>
    </div>
    <div class="ext-links ac-flex">
      <div class="ac-flex-col ac-gap-sm ac-pd-0-sm">
        <div class="ac-title-md">About</div>
        <a routerLink="postal-request-code">
          <span class="ac-label ac-body-md">Postal Request Code</span>
        </a>
        @if (showVipLink()) {
          <a routerLink="vip">
            <span class="ac-label ac-body-md">VIP Program</span>
          </a>
        }
        <a (click)="openCustomerSupport()">
          <span class="ac-label ac-body-md">Customer Support</span>
        </a>
      </div>
      <div class="ac-flex-col ac-gap-sm ac-pd-0-sm">
        <div class="ac-title-md">Legal</div>
        <a routerLink="terms-and-conditions">
          <span class="ac-label ac-body-md">Terms and Conditions</span>
        </a>
        <a routerLink="privacy-policy">
          <span class="ac-label ac-body-md">Privacy Policy</span>
        </a>
        <a routerLink="sweepstakes-rules">
          <span class="ac-label ac-body-md">Sweepstakes Rules</span>
        </a>
        <a href="https://help.gains.com/en/articles/16574302-how-our-sweepstakes-work" target="_blank" rel="noopener noreferrer">
          <span class="ac-label ac-body-md">How Our Sweepstakes Work</span>
        </a>
        <a routerLink="responsible-gaming">
          <span class="ac-label ac-body-md">Responsible Social Gaming</span>
        </a>
      </div>
    </div>
  </div>

  <hr class="footer-divider" />
  <div class="ac-flex-col ac-gap-xl">
    <div class="ac-flex ac-gap-sm ac-algn-ctr ac-label ac-body-sm made-in-usa">
      <ac-icon iconKey="hr:us_flag" [size]="16" />
      Made, Owned, and Operated in the USA
    </div>

    <div class="footer-text ac-flex ac-gap-lg ac-algn-strt">
      <div class="registration ac-flex-itm-100 ac-body-sm ac-label">
        No purchase necessary. Void where prohibited. Gains.com is owned and operated by GamerGains Labs, Inc. and is
        headquartered in Miami, Florida.
      </div>
      <div class="warning ac-flex ac-flex-itm-100 ac-algn-ctr ac-body-sm ac-label ac-gap-sm">
        <ac-icon iconKey="hr:18_plus" /> Persons under the age of 18 are not permitted to create accounts and/or
        participate in the games.
      </div>
    </div>

    <div class="ac-flex ac-gap-lg payment-options">
      <ac-icon iconKey="payment:apple_pay" [size]="32" />
      <ac-icon iconKey="payment:google_pay" [size]="32" />
      <ac-icon iconKey="payment:mastercard" [size]="32" />
      <ac-icon iconKey="payment:visa" [size]="32" />
      <ac-icon iconKey="payment:amex" [size]="32" />
      <ac-icon iconKey="payment:discover" [size]="32" />
    </div>
  </div>
</footer>
